import React, { Suspense } from "react";
import { GlobalContext } from "../Utils/contexts.js";
import { getTooltipStyles } from "./tooltip-styles.js";
const lazyWithPreload = (factory) => {
  const Component = React.lazy(factory);
  Component.preload = factory;
  return Component;
};
const ToolTipComponent = lazyWithPreload(async () => {
  const result = await import(
    /* webpackChunkName: "react-portal-tooltip" */
    "react-portal-tooltip"
  );
  return result.default?.default ? result.default : result;
});
class Tooltip extends React.Component {
  constructor() {
    super(...arguments);
    this.disabled = false;
    this.mousePosition = { x: 0, y: 0 };
    this.state = {
      tooltipVisible: false
    };
    this.showTooltip = (e) => {
      ToolTipComponent.preload();
      if (!e.target.disabled) {
        this.mousePosition = { x: e.pageX, y: e.pageY };
        this.timeoutId = setTimeout(() => {
          this.setState({ tooltipVisible: true }, () => {
            this.forceUpdate();
            setTimeout(() => this.props.followMouse && this.updateTooltipPosition());
          });
        }, 300);
      }
    };
    this.onMouseMove = (e) => {
      if (this.props.followMouse) {
        this.mousePosition = { x: e.pageX, y: e.pageY };
        this.updateTooltipPosition();
      }
    };
    this.updateTooltipPosition = () => {
      const { x, y } = this.mousePosition;
      const element = document.querySelector(".ToolTipPortal > div");
      if (element) {
        const { offsetWidth: width, offsetHeight: height } = element;
        element.style.left = `${x - width / 2}px`;
        element.style.top = `${y - height - 25}px`;
      }
    };
    this.hideTooltip = () => {
      clearTimeout(this.timeoutId);
      this.setState({ tooltipVisible: false });
    };
    this.wrappChildrenProp = (propName, func) => {
      return {
        [propName]: (e) => {
          func(e);
          this.props.children.props[propName]?.(e);
        }
      };
    };
    this.wrapperProps = {
      ...this.wrappChildrenProp("onMouseEnter", this.showTooltip),
      ...this.wrappChildrenProp("onMouseLeave", this.hideTooltip),
      ...this.wrappChildrenProp("onClick", this.hideTooltip),
      ...this.wrappChildrenProp("onMouseMove", this.onMouseMove)
    };
  }
  componentDidUpdate() {
    this.disabled = window.richContentHideTooltips;
  }
  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }
  render() {
    const {
      children,
      content,
      isError,
      place,
      tooltipOffset,
      followMouse,
      hideArrow,
      forceVisibility
    } = this.props;
    const { tooltipVisible } = this.state;
    const { isMobile } = this.context;
    const style = getTooltipStyles(isError, followMouse, tooltipOffset, place);
    const elementProps = forceVisibility || tooltipVisible ? { ...this.wrapperProps, "data-tooltipid": true } : this.wrapperProps;
    const tooltipArrow = hideArrow ? null : "center";
    return isMobile || this.disabled || !content ? children : /* @__PURE__ */ React.createElement(React.Fragment, null, React.cloneElement(React.Children.only(children), elementProps), forceVisibility || tooltipVisible ? /* @__PURE__ */ React.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React.createElement(
      ToolTipComponent,
      {
        active: forceVisibility || tooltipVisible,
        parent: "[data-tooltipid=true]",
        position: place,
        arrow: tooltipArrow,
        style,
        tooltipTimeout: 10,
        group: "ricos"
      },
      content
    )) : null);
  }
}
Tooltip.defaultProps = {
  isError: false,
  place: "top",
  tooltipOffset: { x: 0, y: 0 }
};
Tooltip.contextType = GlobalContext;
export {
  Tooltip
};
//# sourceMappingURL=tooltip.js.map
